import { HeaderBar } from 'components/HeaderBar';
import { LoadingAndErrors } from 'components/LoadingAndErrors';
import PageLayout from 'components/PageLayout';
import { SimplePageLayout } from 'components/layouts/SimplePageLayout';
import { EditOrganizationMemberForm } from 'features/users/components/EditOrganizationMemberForm';
import { useOrganizationMember } from 'features/users/hooks/useOrganizationMember';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { Redirect, RouteComponentProps } from 'react-router-dom';
import { useAuthState } from 'state/useAuthState';

export const OrganizationMemberDetails = (
  props: RouteComponentProps<{ memberId?: string }>,
): JSX.Element => {
  const {
    match: {
      params: { memberId },
    },
  } = props;
  const { t } = useTranslation();
  const {
    permissions: { canManageOrganization },
  } = useAuthState();

  const { member, saveMember, updateMember, deleteMember, isLoading, error } =
    useOrganizationMember({
      memberId: memberId ? parseInt(memberId, 10) : undefined,
      enabled: canManageOrganization,
    });

  if (!canManageOrganization) {
    return <Redirect to="/" />;
  }

  if (isLoading || error) {
    return (
      <PageLayout data-cname="OrganizationMemberDetails">
        {{
          content: <LoadingAndErrors isLoading={isLoading} />,
          headerBar: <HeaderBar action="back" />,
        }}
      </PageLayout>
    );
  }

  return (
    <PageLayout data-cname="OrganizationMemberDetails">
      {{
        content: (
          <>
            <Helmet>
              <title>{t('organizationMember.title')}</title>
            </Helmet>
            <SimplePageLayout>
              <EditOrganizationMemberForm
                member={member}
                saveMember={saveMember}
                updateMember={updateMember}
                deleteMember={deleteMember}
              />
            </SimplePageLayout>
          </>
        ),
        headerBar: (
          <HeaderBar title={t('organizationMember.title')} action="back" />
        ),
      }}
    </PageLayout>
  );
};
